import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { TranscriptionHistory } from 'entities/transcription_history'
import { ReactNode, useMemo } from 'react'
import { Badge } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { TranscriptionHistoryViewModel } from 'view_models/transcription_history_view_model'

export const transcriptionHistoryColumnInfoList = (): ColumnInfoList => {
    const values: ColumnInfo[] = [
        { name: 'ID', th: true, width: 70, align: 'center' },
        { name: '転記日時', th: true, width: 130 },
        { name: 'スタッフ', th: true, width: 120 },
        { name: 'ステータス', th: true, width: 90, align: 'center' },
    ]
    values.push({ name: '件数', th: true, align: 'center', width: 140 })
    values.push({ name: 'メモ', th: true, minWidth: 300 })

    return {
        tableName: '',
        values: values,
    }
}

export type TranscriptionHistoryTableDataProps = {
    transcriptionHistory?: TranscriptionHistory
    displaySetting: DisplaySetting
}

export const TranscriptionHistoryTableData = ({ transcriptionHistory, displaySetting }: TranscriptionHistoryTableDataProps): JSX.Element => {
    if (!transcriptionHistory) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        const vm = new TranscriptionHistoryViewModel(transcriptionHistory)
        return (
            <>
                <TableCell align="center">{transcriptionHistory.id}</TableCell>
                <TableCell>{vm.createdAtText()}</TableCell>
                <TableCell>{transcriptionHistory.user?.fullName}</TableCell>
                <TableCell align="center">
                    {transcriptionHistory.isCompleted ? (
                        <Badge bg="success" style={{ width: 50 }}>
                            完了
                        </Badge>
                    ) : (
                        <Badge bg="danger" style={{ width: 50 }}>
                            未処理
                        </Badge>
                    )}
                </TableCell>
                <TableCell align="center">
                    <Link to={`/${vm.getPath()}?transcriptionHistoryId=${transcriptionHistory.id}`}>
                        {transcriptionHistory.itemCount} {transcriptionHistory.type}
                    </Link>
                </TableCell>
                <TableCell>{transcriptionHistory.note}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
